// components/SeedFormModal.tsx
import React from "react";
import Modal from "Common/Components/Modal";
import Select from "react-select";
import FarmerInfoForModal from "Common/FarmerInfoForModal";
import FarmerIdentityInfo from "Common/Components/FarmerIdentityInfo";

interface SeedFormModalProps {
  show: boolean;
  isEdit: boolean;
  onHide: () => void;
  setSeedSearchValue: (a: any) => void;
  onSubmit: (e: React.MouseEvent<HTMLButtonElement>) => void;
  validation: any;
  selectedCommitment: any;
  setSelectedCommitment: (commitment: any) => void;
  setcoomitID: (id: string) => void;
  setsetSearchValueCommit: (value: string) => void;
  commitment_idList: any[];
  FarmerNameForEdit: string;
  isLoadingBtnModal: boolean;
  selectedFarmerInfo: any;
  coomitID: any;
  dataSeedID: string;
  setDataSeedID: (id: string) => void;
  dataSeedList: any[];
  seednameForEdit: string;
  dataFactoryID: string;
  setDataFactoryID: (id: string) => void;
  dataFactoryList: any[];
  FactoryName: string;
  defultcheckedPrice: boolean;
  setdefultcheckedPrice: (checked: boolean) => void;
  YearCoptSelect: string;
  isLoadingBtn: boolean;
  formatNumber: (num: number | string) => string;
  parseFormattedNumber: (formattedNum: string) => string;
}

const SeedFormModal: React.FC<SeedFormModalProps> = ({
  show,
  isEdit,
  coomitID,
  onHide,
  onSubmit,
  validation,
  selectedCommitment,
  setSelectedCommitment,
  setcoomitID,
  setsetSearchValueCommit,
  commitment_idList,
  setSeedSearchValue,
  FarmerNameForEdit,
  isLoadingBtnModal,
  selectedFarmerInfo,
  dataSeedID,
  setDataSeedID,
  dataSeedList,
  seednameForEdit,
  dataFactoryID,
  setDataFactoryID,
  dataFactoryList,
  FactoryName,
  defultcheckedPrice,
  setdefultcheckedPrice,
  YearCoptSelect,
  isLoadingBtn,
  formatNumber,
  parseFormattedNumber,
}) => {
  return (
    <Modal
      show={show}
      onHide={onHide}
      modal-center="true"
      className="fixed flex flex-col transition-all duration-300 ease-in-out left-2/4 z-drawer -translate-x-2/4 -translate-y-2/4"
      dialogClassName="w-screen md:w-[30rem] bg-white shadow rounded-md dark:bg-zink-600"
    >
      <Modal.Header
        className="flex items-center justify-between p-4 border-b dark:border-zink-500"
        closeButtonClass="transition-all duration-200 ease-linear text-slate-400 hover:text-red-500"
      >
        <Modal.Title className="text-16">
          {!!isEdit ? "به روز رسانی اطلاعات" : "ثبت بذر "}
        </Modal.Title>
      </Modal.Header>

      <Modal.Body className="max-h-[calc(theme('height.screen')_-_180px)] p-4 overflow-y-auto">
        <form
          className="create-form"
          id="create-form"
          onSubmit={validation.handleSubmit}
        >
          <div className="grid grid-cols-1 mr-6 gap-4 xl:grid-cols-12">
            <div className="xl:col-span-11 dark:text-white text-gray-800 space-y-4">
              {/* نام کشاورز */}
              <label htmlFor="province" className="text-base font-medium">
                نام کشاورز :
              </label>
              <Select
                value={selectedCommitment}
                options={commitment_idList?.map((item: any) => ({
                  value: item.id,
                  label: item.farmer_name,
                  farmerId: item.farmer_id,
                }))}
                onChange={(selected: any) => {
                  setSelectedCommitment(selected);
                  setcoomitID(selected?.value);
                }}
                onInputChange={(inputValue) => {
                  setsetSearchValueCommit(inputValue);
                }}
                styles={{
                  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                  control: (base, state) => ({
                    ...base,
                    backgroundColor: "inherit",
                    boxShadow: state.isFocused ? "0 0 0 1px #2684FF" : "none",
                  }),
                  option: (base, state) => ({
                    ...base,
                    color: "inherit",
                    "&:hover": {
                      backgroundColor: "#2684FF",
                    },
                  }),
                }}
                menuPortalTarget={document.body}
                placeholder="جستجو ..."
                noOptionsMessage={() => "داده‌ای دریافت نشد"}
                loadingMessage={() => "در حال بارگذاری..."}
                className="w-full my-react-select-container"
                classNamePrefix="my-react-select"
                maxMenuHeight={300}
                isSearchable
              />

              {isEdit && (
                <div className="flex items-center space-x-4">
                  <span className="font-medium">✅ نام کشاورز :</span>
                  <span className="px-1">{FarmerNameForEdit || "-"}</span>
                </div>
              )}

              {!isEdit && coomitID && (
                <div className="mt-2">
                  {isLoadingBtnModal ? (
                    <span className="bg-green-200 mt-8 dark:bg-zink-600 p-2 rounded-md text-xs text-gray-500 ">
                      در حال دریافت داده ...
                    </span>
                  ) : (
                    <FarmerInfoForModal
                      selectedFarmerInfo={selectedFarmerInfo}
                    />
                  )}
                </div>
              )}

              {!isEdit && (
                <FarmerIdentityInfo
                  farmerId={selectedCommitment?.farmerId}
                  className="mt-2"
                />
              )}

              {/* نام بذر */}
              <div className="flex flex-col">
                <label
                  htmlFor="province"
                  className="text-base font-medium mb-1"
                >
                  نام بذر:
                </label>
                <Select
                  value={
                    dataSeedID
                      ? {
                        value: dataSeedID,
                        label:
                          dataSeedList.find(
                            (item: any) => item.id === dataSeedID
                          )?.seed_name || "",
                      }
                      : null
                  }
                  options={dataSeedList.map((item: any) => ({
                    value: item.id,
                    label: item.seed_name,
                  }))}
                  onInputChange={(inputValue) => setSeedSearchValue(inputValue)}
                  styles={{
                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    control: (base, state) => ({
                      ...base,
                      backgroundColor: "inherit",
                      boxShadow: state.isFocused ? "0 0 0 1px #2684FF" : "none",
                    }),
                    option: (base, state) => ({
                      ...base,
                      color: "inherit",
                      "&:hover": {
                        backgroundColor: "#2684FF",
                      },
                    }),
                  }}
                  menuPortalTarget={document.body}
                  onChange={(selected: any) => setDataSeedID(selected.value)}
                  placeholder="جستجو..."
                  noOptionsMessage={() => "داده‌ای دریافت نشد"}
                  loadingMessage={() => "در حال بارگذاری..."}
                  className="w-full my-react-select-container"
                  classNamePrefix="my-react-select"
                  maxMenuHeight={300}
                  isSearchable
                />
                {isEdit && (
                  <div className="bg-gray-50 dark:bg-gray-700 p-4 rounded-lg space-y-3">
                    <div className="flex items-center space-x-4">
                      <span className="font-medium">✅ بذر انتخاب شده :</span>
                      <span className="px-1">{seednameForEdit || "-"}</span>
                    </div>
                  </div>
                )}
              </div>

              {/* نام کارخانه */}
              <div className="flex flex-col">
                <label
                  htmlFor="province"
                  className="text-base font-medium mb-1"
                >
                  نام کارخانه:
                </label>
                <Select
                  value={
                    dataFactoryID
                      ? {
                        value: dataFactoryID,
                        label:
                          dataFactoryList.find(
                            (item: any) => item.id === dataFactoryID
                          )?.factory_name || "",
                      }
                      : null
                  }
                  options={dataFactoryList.map((item: any) => ({
                    value: item.id,
                    label: item.factory_name,
                  }))}
                  styles={{
                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    control: (base, state) => ({
                      ...base,
                      backgroundColor: "inherit",
                      boxShadow: state.isFocused ? "0 0 0 1px #2684FF" : "none",
                    }),
                    option: (base, state) => ({
                      ...base,
                      color: "inherit",
                      "&:hover": {
                        backgroundColor: "#2684FF",
                      },
                    }),
                  }}
                  menuPortalTarget={document.body}
                  onChange={(selected: any) => setDataFactoryID(selected.value)}
                  placeholder="جستجو..."
                  noOptionsMessage={() => "داده‌ای دریافت نشد"}
                  loadingMessage={() => "در حال بارگذاری..."}
                  className="w-full my-react-select-container"
                  classNamePrefix="my-react-select"
                  maxMenuHeight={300}
                  isSearchable
                />

                {isEdit && (
                  <div className="bg-gray-50 dark:bg-gray-700 p-4 rounded-lg space-y-3">
                    <div className="flex items-center space-x-4">
                      <span className="font-medium">
                        ✅ نام کارخانه انتخاب شده :
                      </span>
                      <span className="px-1">{FactoryName || "-"}</span>
                    </div>
                  </div>
                )}
              </div>

              {/* مقدار/تعداد */}
              <div className="flex flex-col">
                <label
                  htmlFor="seed_amount"
                  className="text-base font-medium mb-1"
                >
                  مقدار/تعداد:
                </label>
                <input
                  type="number"
                  id="seed_amount"
                  className="form-input dark:bg-gray-800 dark:text-white text-black font-[12px] w-full"
                  placeholder="0"
                  name="seed_amount"
                  autoComplete="off"
                  onChange={validation.handleChange}
                  value={validation.values.seed_amount}
                />
                {validation.touched.seed_amount &&
                  validation.errors.seed_amount && (
                    <p className="text-red-400 mt-1">
                      {typeof validation.errors.seed_amount === "string"
                        ? validation.errors.seed_amount
                        : Array.isArray(validation.errors.seed_amount)
                          ? validation.errors.seed_amount.join(", ")
                          : JSON.stringify(validation.errors.seed_amount)}
                    </p>
                  )}
              </div>

              {/* قیمت */}
              <div className="flex flex-row items-center gap-4">
                <div className="flex mt-4 items-center">
                  <input
                    type="checkbox"
                    checked={defultcheckedPrice}
                    id="pricedefult"
                    className="form-input py-2 mt-[-0.5rem] dark:bg-gray-800 dark:text-white text-black font-[12px]"
                    name="pricedefult"
                    autoComplete="off"
                    onClick={() => setdefultcheckedPrice(!defultcheckedPrice)}
                  />
                  <label
                    htmlFor="pricedefult"
                    className="text-base whitespace-nowrap font-medium mb-1 mr-2"
                  >
                    قیمت ثبت شده برای کشاورزان
                  </label>
                </div>

                <div className="flex flex-col items-center">
                  <label
                    htmlFor="price"
                    className="text-base font-medium mb-1 mr-2"
                  >
                    قیمت دلخواه
                  </label>
                  <input
                    type="text"
                    id="priceinput"
                    className={`${defultcheckedPrice ? "cursor-not-allowed" : ""
                      } form-input dark:bg-gray-800 dark:text-white text-black font-[12px] w-20`}
                    placeholder="0"
                    name="priceinput"
                    autoComplete="off"
                    onChange={(e) => {
                      const value = parseFormattedNumber(e.target.value);
                      validation.setFieldValue("priceinput", value);
                    }}
                    value={formatNumber(validation.values.priceinput)}
                    disabled={defultcheckedPrice}
                  />
                </div>
              </div>

              {!isEdit && (
                <div className="">
                  سال زراعی انتخاب شده:
                  <span className="text-custom-600 dark:text-gray-200 bold">
                    {YearCoptSelect ? YearCoptSelect : ""}{" "}
                  </span>{" "}
                </div>
              )}
            </div>
          </div>
        </form>
      </Modal.Body>

      <Modal.Footer className="flex justify-center p-4 border-t dark:border-zink-500">
        <button
          type="button"
          onClick={onSubmit}
          className="px-4 py-2 mt-4 font-bold justify-end text-white bg-blue-500 rounded hover:bg-blue-600"
        >
          {isLoadingBtn
            ? "در حال ارسال..."
            : isEdit
              ? "به روز رسانی اطلاعات"
              : "ثبت اطلاعات"}{" "}
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default SeedFormModal;
